module.exports = __webpack_public_path__ + "static/media/deemed.66898b9b.svg";